export const underShardResources = ['token', 'cpuUnlock', 'pixel', 'accessKey'];
